import { render, staticRenderFns } from "./LabeledText.vue?vue&type=template&id=0a63a660&scoped=true&"
import script from "./LabeledText.vue?vue&type=script&lang=js&"
export * from "./LabeledText.vue?vue&type=script&lang=js&"
import style0 from "./LabeledText.vue?vue&type=style&index=0&id=0a63a660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63a660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
